import { workflowConstants } from '../constants'

export const Workflow = (state = {}, action) => {
  switch (action.type) {
    case workflowConstants.WORKFLOW_REQUEST:
      return { loading: true, items: undefined, error: undefined }

    case workflowConstants.WORKFLOW_SUCCESS:
      return { loading: false, items: action.workflowData.Body, error: undefined }

    case workflowConstants.WORKFLOW_FAILURE:
      return { loading: false, items: undefined, error: action.error }

    default:
      return state
  }
}


export const WorkflowRes = (state = {}, action) => {
  switch (action.type) {
    case workflowConstants.WORKFLOW_RES_REQUEST:
      return { loading: true, items: undefined, error: undefined }

    case workflowConstants.WORKFLOW_RES_SUCCESS:
      return { loading: false, items: action.workflowData.Body, error: undefined }

    case workflowConstants.WORKFLOW_RES_FAILURE:
      return { loading: false, items: undefined, error: action.error }

    default:
      return state
  }
}

export const ContinueWorkflow = (state = {}, action) => {
  switch (action.type) {
    case workflowConstants.CONTINUE_WORKFLOW_REQUEST:
      return { loading: true, items: undefined, error: undefined }

    case workflowConstants.CONTINUE_WORKFLOW_SUCCESS:
      return { loading: false, items: action.workflowData.Body, error: undefined }

    case workflowConstants.CONTINUE_WORKFLOW_FAILURE:
      return { loading: false, items: undefined, error: action.error }
      
    case workflowConstants.CONTINUE_WORKFLOW_RESET:
      return { loading: false, items: undefined, error: undefined }

    default:
      return state
  }
}

export const CancelWorkFlow = (state = {}, action) => {
  switch (action.type) {
    case workflowConstants.CANCEL_WORKFLOW_REQUEST:
      return { loading: true, items: undefined, error: undefined }

    case workflowConstants.CANCEL_WORKFLOW_SUCCESS:
      return { loading: false, items: action.cancelWFData.Body, error: undefined }

    case workflowConstants.CANCEL_WORKFLOW_FAILURE:
      return { loading: false, items: undefined, error: action.error }

    default:
      return state
  }
}

export const WorkflowDefinicion = (state = {}, action) => {
  switch (action.type) {
    case workflowConstants.WORKFLOW_DEFINICION_REQUEST:
      return { loading: true, items: undefined, error: undefined }

    case workflowConstants.WORKFLOW_DEFINICION_SUCCESS:
      return { loading: false, items: action.workflowDefinicionData.Body, error: undefined }

    case workflowConstants.WORKFLOW_DEFINICION_FAILURE:
      return { loading: false, items: undefined, error: action.error }

    default:
      return state
  }
}

export const Binnacle = (state = {}, action) => {
  switch (action.type) {
    case workflowConstants.GET_BINNACLE_REQUEST:
      return { loading: true, items: undefined, error: undefined }

    case workflowConstants.GET_BINNACLE_SUCCESS:
      return { loading: false, items: action.binnacleData.Body, error: undefined }

    case workflowConstants.GET_BINNACLE_FAILURE:
      return { loading: false, items: undefined, error: action.error }

    default:
      return state
  }
}

export const RegStatusStage = (state = {}, action) => {
  switch (action.type) {
    case workflowConstants.REG_STATUSSTAGE_REQUEST:
      return { loading: true, items: undefined, error: undefined }

    case workflowConstants.REG_STATUSSTAGE_SUCCESS:
      return { loading: false, items: action.regStatusStage.Body, error: undefined }

    case workflowConstants.REG_STATUSSTAGE_FAILURE:
      return { loading: false, items: undefined, error: action.error }

    default:
      return state
  }
}